import * as z from "zod/v4";

export const firstInstallOnboardingAttributionBucketSchema = z.object({
  attributionSource: z.string().nullable(),
  label: z.string(),
  count: z.number().int().min(0),
  percentage: z.number().min(0),
});

export type FirstInstallOnboardingAttributionBucket = z.infer<
  typeof firstInstallOnboardingAttributionBucketSchema
>;

export const firstInstallOnboardingProductBucketSchema = z.object({
  product: z.string().nullable(),
  label: z.string(),
  count: z.number().int().min(0),
  percentage: z.number().min(0),
});

export type FirstInstallOnboardingProductBucket = z.infer<
  typeof firstInstallOnboardingProductBucketSchema
>;

export const firstInstallOnboardingAttributionProductBucketSchema =
  firstInstallOnboardingAttributionBucketSchema.extend({
    productBreakdown: z.array(firstInstallOnboardingProductBucketSchema),
  });

export type FirstInstallOnboardingAttributionProductBucket = z.infer<
  typeof firstInstallOnboardingAttributionProductBucketSchema
>;

export const firstInstallOnboardingProductAttributionBucketSchema =
  firstInstallOnboardingProductBucketSchema.extend({
    attributionBreakdown: z.array(
      firstInstallOnboardingAttributionBucketSchema,
    ),
  });

export type FirstInstallOnboardingProductAttributionBucket = z.infer<
  typeof firstInstallOnboardingProductAttributionBucketSchema
>;

export const getFirstInstallOnboardingAttribution = {
  name: "getFirstInstallOnboardingAttribution" as const,
  input: z.object({}),
  output: z.object({
    generatedAt: z.string(),
    totalWithFirstInstallOnboarding: z.number().int().min(0),
    totalWithAttributionSource: z.number().int().min(0),
    totalWithOnboardingProduct: z.number().int().min(0),
    incompleteAttributionCount: z.number().int().min(0),
    incompleteProductCount: z.number().int().min(0),
    buckets: z.array(firstInstallOnboardingAttributionProductBucketSchema),
    productBuckets: z.array(
      firstInstallOnboardingProductAttributionBucketSchema,
    ),
  }),
};

export type GetFirstInstallOnboardingAttributionInput = z.infer<
  typeof getFirstInstallOnboardingAttribution.input
>;

export type GetFirstInstallOnboardingAttributionOutput = z.infer<
  typeof getFirstInstallOnboardingAttribution.output
>;
